import { Card, Row, Col, Typography, Button, Empty, Space, Spin } from "antd";
import { useState, useEffect } from "react";
import localforage from "localforage";
import { StarFilled, StarOutlined, MessageTwoTone } from "@ant-design/icons";

const { Text, Title } = Typography;

const QueueRow = ({
  queue,
  openDetailsModal,
  refreshBusiness,
  setShowAlertModal,
  isMobile,
}) => {
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    const checkFavorite = async () => {
      const favorites = (await localforage.getItem("favorites_userIds")) || [];
      setIsFavorite(favorites.includes(queue.userId));
    };
    checkFavorite();
  }, [queue.userId]);

  const toggleFavorite = async () => {
    const favorites = (await localforage.getItem("favorites_userIds")) || [];
    const newFavorites = isFavorite
      ? favorites.filter((id) => id !== queue.userId)
      : [...favorites, queue.userId];
    await localforage.setItem("favorites_userIds", newFavorites);
    setIsFavorite(!isFavorite);
  };

  return (
    <>
      <Col xs={24} sm={12} md={8} lg={6} key={queue.userId}>
        {refreshLoading ? (
          <Card
            className="queue-card"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "150px",
            }}
          >
            <Spin size="large" />
          </Card>
        ) : (
          <Card className="queue-card">
            <div className="queue-card-header">
              <Text strong className="businessHeadingClass">
                {queue.businessName}{" "}
                <span className="pinCodeClass">
                  {" ("}
                  {queue.pincode || 400081}
                  {")"}
                </span>
              </Text>
              <div>
                <Title style={{ color: "#0c5c25e0" }} level={2}>
                  {queue.queueNumber}
                </Title>
              </div>
            </div>
            <Row gutter={[16, 16]} align="middle" className="queue-info">
              <Col flex="auto">
                <div className={`${queue.isActive ? "active" : "inactive"}`}>
                  {queue.isActive ? "OPEN" : "CLOSED"}
                </div>
              </Col>
              <Col>
                <Space>
                  <Button
                    style={{
                      backgroundColor: "#a89997",
                    }}
                    loading={detailsLoading}
                    onClick={() => {
                      setDetailsLoading(true);
                      openDetailsModal(queue.userId, setDetailsLoading);
                    }}
                  >
                    Details
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#a89997",
                    }}
                    onClick={() => {
                      setRefreshLoading(true);
                      refreshBusiness(queue.userId, setRefreshLoading);
                    }}
                  >
                    Refresh
                  </Button>
                </Space>
              </Col>
            </Row>
            <Button
              type="text"
              icon={isFavorite ? <StarFilled /> : <StarOutlined />}
              onClick={toggleFavorite}
              style={{
                position: "absolute",
                top: "7px",
                right: "16px",
                zIndex: 1,
                color: isFavorite ? "#ffcc00" : "#000",
                fontSize: "18px",
              }}
            />
            {queue?.businessMessage?.message?.length ? (
              <>
                <div style={{ display: "flex" }}>
                  {/* Replace the button with a red cross icon */}
                  <div className="crossIconParent1">
                    <MessageTwoTone
                      style={{
                        color: "#ec7f56cc",
                        fontSize: "16px",
                        marginTop: "4px",
                      }}
                    />
                  </div>{" "}
                  <div
                    style={{
                      marginLeft: "5px",
                      flex: 1,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span className="messageArea">
                      {queue.businessMessage.message}
                    </span>
                  </div>
                </div>
                <div>
                  <span className="timeArea" style={{ marginTop: "-5px" }}>
                    {" -"}
                    {"sent at "}
                    {queue.businessMessage.time}
                  </span>
                </div>
              </>
            ) : null}
          </Card>
        )}
      </Col>
    </>
  );
};

export default function QueueList({
  queueData,
  selectedBusinessType,
  isMobile,
  setShowAlertModal,
  openDetailsModal,
  refreshBusiness,
}) {
  const [maxHeight, setMaxHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setMaxHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="cardsContainer">
      <div className="results-header">
        {queueData.length ? (
          <>
            Showing results for <b>{selectedBusinessType}</b>
          </>
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "24px 16px",
              margin: "16px 0",
              borderRadius: "8px",
              background: "#fafafa",
            }}
          >
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  <Title level={5} style={{ marginBottom: 8 }}>
                    No results found for{" "}
                    <Text strong>{selectedBusinessType}</Text>
                  </Title>
                  <Text type="secondary">
                    Please suggest your nearby {selectedBusinessType}s about
                    this app
                  </Text>
                </>
              }
            />
          </div>
        )}
      </div>
      <div>
        <Row
          gutter={[2, 2]}
          className="scrollable-row"
          style={{ maxHeight: `${maxHeight * 0.86}px` }}
        >
          {queueData.map((queue) => (
            <QueueRow
              key={queue.userId}
              queue={queue}
              openDetailsModal={openDetailsModal}
              refreshBusiness={refreshBusiness}
              setShowAlertModal={setShowAlertModal}
              isMobile={isMobile}
            />
          ))}
        </Row>
      </div>
    </div>
  );
}
